import Vue from "vue";
import Router from "vue-router";
import Layout from "@/page/Layout";
import indexHome from "@/page/indexHome";
import indexSpecial from "@/page/indexSpecial";
import indexResources from "@/page/indexResources";
import IndexPage from "@/page/IndexPage";
import login from "@/page/login";
import loginPrinting from "@/page/loginPrinting";
import print from "@/page/print";
import printManagement from "@/page/printManagement";
import printStatistics from "@/page/printStatistics";

import resource from "@/page/resource/index1";
import resourceUpload from "@/page/resource/upload2";

import audit from "@/page/audit/layout";
import auditExamine from "@/page/audit/examine";
import auditClassroom from "@/page/audit/classroomAudit";
import classExamine from "@/page/audit/classExamine";

import classroom from "@/page/classroom/index";

import special from "@/page/special/list";
import specialAdd from "@/page/special/add";
import specialDetails from "@/page/special/details";

import my from "@/page/my";
import myUpload from "@/page/my/upload";
import myCollection from "@/page/my/collection";
import myDownload from "@/page/my/download";
import myPrinting from "@/page/my/printing";

import statistics from "@/page/statistics";
import statisticsResources from "@/page/statistics/resources";
import statisticsPeople from "@/page/statistics/people";
import statisticsSchool from "@/page/statistics/school";
import statisticsPrint from "@/page/statistics/print";

import manage from "@/page/manage/manage";
import manageRole from "@/page/manage/role";
import schoolManagerRole from "@/page/manage/schoolManagerRole";
import manageCategory from "@/page/manage/category";
import manageBanner from "@/page/manage/banner";
import manageExamine from "@/page/manage/examine";
import managePrinter from "@/page/manage/printer";
import manageSync from "@/page/manage/sync";
import whiteList from "@/page/manage/whiteList";
import a from "@/page/a";
import b from "@/page/b";

import preview from "@/page/preview";
import edition from "@/page/edition";

Vue.use(Router);

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Layout",
      redirect: {
        name: "IndexPage"
      },
      component: Layout,
      children: [
        {
          path: "/indexSpecial",
          name: "indexSpecial",
          redirect: {
            name: "special"
          },
          component: indexSpecial,
          children: [
            // 专题
            {
              path: "/special",
              name: "special",
              component: special,
              children: []
            },
            {
              path: "/special/add",
              name: "specialAdd",
              component: specialAdd,
              children: []
            },
            {
              path: "/special/details",
              name: "specialDetails",
              component: specialDetails,
              children: []
            }
          ]
        },
        {
          path: "/indexResources",
          name: "indexResources",
          redirect: {
            name: "special"
          },
          component: indexResources,
          children: [
            // 资源中心
            {
              path: "/resource",
              name: "resource",
              component: resource,
              children: []
            },
            {
              path: "/resource/upload",
              name: "resourceUpload",
              component: resourceUpload,
              children: []
            },
            // 待审批
            {
              path: "/audit",
              name: "audit",
              // redirect: {
              //   name: "auditExamine"
              // },
              component: audit,
              children: [
                {
                  path: "/audit/examine",
                  name: "auditExamine",
                  component: auditExamine
                },
                {
                  path: "/audit/classroomAudit",
                  name: "auditClassroom",
                  component: auditClassroom
                },
                {
                  path: "/audit/classExamine",
                  name: "auditClassExamine",
                  component: classExamine
                }
              ]
            },
            // 我的
            {
              path: "/my",
              name: "my",
              component: my,
              redirect: {
                name: "myUpload"
              },
              children: [
                {
                  path: "/my/upload",
                  name: "myUpload",
                  component: myUpload,
                  children: []
                },
                {
                  path: "/my/collection",
                  name: "myCollection",
                  component: myCollection,
                  children: []
                },
                {
                  path: "/my/download",
                  name: "myDownload",
                  component: myDownload,
                  children: []
                },
                {
                  path: "/my/printing",
                  name: "myPrinting",
                  component: myPrinting,
                  children: []
                }
              ]
            },
            //三师课堂
            {
              path: "/classroom",
              name: "classroom",
              component: classroom,
              children: []
            },
            // 统计
            {
              path: "/statistics",
              name: "statistics",
              component: statistics,
              redirect: {
                name: "statisticsResources"
              },
              children: [
                {
                  path: "/statistics/resources",
                  name: "statisticsResources",
                  component: statisticsResources,
                  children: []
                },
                {
                  path: "/statistics/people",
                  name: "statisticsPeople",
                  component: statisticsPeople,
                  children: []
                },
                {
                  path: "/statistics/school",
                  name: "statisticsSchool",
                  component: statisticsSchool,
                  children: []
                },
                {
                  path: "/statistics/print",
                  name: "statisticsPrint",
                  component: statisticsPrint,
                  children: []
                }
              ]
            },
            // 后台管理
            {
              path: "/manage",
              name: "manage",
              component: manage,

              children: [
                {
                  path: "/manage/role",
                  name: "manageRole",
                  component: manageRole,
                  children: []
                },
                {
                  path: "/manage/schoolManagerRole",
                  name: "schoolManagerRole",
                  component: schoolManagerRole,
                  children: []
                },
                {
                  path: "/manage/category",
                  name: "manageCategory",
                  component: manageCategory,
                  children: []
                },
                {
                  path: "/manage/banner",
                  name: "manageBanner",
                  component: manageBanner,
                  children: []
                },
                {
                  path: "/manage/examine",
                  name: "manageExamine",
                  component: manageExamine,
                  children: []
                },
                {
                  path: "/manage/printer",
                  name: "managePrinter",
                  component: managePrinter,
                  children: []
                },
                {
                  path: "/manage/sync",
                  name: "manageSync",
                  component: manageSync,
                  children: []
                },
                {
                  path: "/manage/whiteList",
                  name: "whiteList",
                  component: whiteList,
                  children: []
                }
              ]
            },
            {
              path: "/edition",
              name: "edition",
              component: edition,
              children: []
            }
          ]
        },
        {
          path: "/home",
          name: "home",
          redirect: {
            name: "IndexPage"
          },
          component: indexHome,
          children: [
            {
              path: "/index",
              name: "IndexPage",
              component: IndexPage,
              children: []
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/loginPrinting",
      name: "loginPrinting",
      component: loginPrinting
    },
    {
      path: "/print",
      name: "print",
      component: print,
      redirect: {
        name: "printManagement"
      },
      children: [
        {
          path: "/printManagement",
          name: "printManagement",
          component: printManagement
        },
        {
          path: "/printStatistics",
          name: "printStatistics",
          component: printStatistics
        }
      ]
    },
    {
      path: "/preview/:watchType/:fileUrl",
      name: "preview",
      component: preview
    },
    {
      path: "/a",
      name: "a",
      component: a
    },
    {
      path: "/b",
      name: "b",
      component: b
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js